import { BillDetailTypes, BillTypes, ServiceFeeTypes } from 'models';
import { useMemo, useRef } from 'react';
import { formatMoney } from 'utils';

export interface ModalProps {
  isShowing: boolean;
  hide: () => void;
  data: BillTypes;
}
export interface TableDataTypes {
  name?: string;
  quantity?: number;
  price?: number;
}
export interface hostTypes {
  [key: number]: string;
}
export interface hostFeeTypes {
  [key: number]: number;
}
export function Modal(props: ModalProps) {
  const { isShowing, hide, data } = props;
  const tableDataRef = useRef<TableDataTypes[]>([]);
  const columns = [
    {
      title: '名前',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '量',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: '価格',
      dataIndex: 'price',
      key: 'price',
    },
  ];
  if (data?.bill_detail) {
    const hostList = data.service_fee?.map((item) => {
      const getHostType = (type: number) => {
        const hostType: hostTypes = {
          1: '本指名',
          2: '場内指名',
          3: '同伴',
          5: 'ヘルプ指名',
        };
        return hostType[type];
      };
      const getHostFee = (type: number) => {
        const hostFee: hostFeeTypes = {
          1: data.nomination_fee,
          2: data.sub_nomination_fee,
          3: data.companion_fee,
          5: data.support_nomination_fee,
        };
        return hostFee[type];
      };
      return {
        name: getHostType(item.type),
        quantity: 1,
        price: getHostFee(item.type),
      };
    });
    const products = data.bill_detail.map((item) => {
      return {
        name: item.name,
        quantity: item.quantity,
        price: item.price * item.quantity,
      };
    });
    const setMenu = data.set_menu?.map((item) => {
      return {
        name: item?.name,
        quantity: item?.quantity,
        price: (item?.init_price || 0) + (item?.extension_price || 0),
      };
    });
    const seatFees = [
      {
        name: 'テーブルチャージ',
        quantity: 1,
        price: data.set_menu?.at(-1)?.seat_fees,
      },
    ];
    tableDataRef.current = [
      ...products,
      ...(setMenu as Array<TableDataTypes>),
      ...seatFees,
      ...(hostList as Array<TableDataTypes>),
    ];
  }
  const totalTable = useMemo(() => {
    const total = tableDataRef.current.reduce((acc, cur) => {
      return acc + (cur?.price || 0);
    }, 0);
    return total;
  }, [data.id]);

  return isShowing ? (
    <>
      {/* modal overlay */}
      <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50" />
      {/* modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full">
        <div className="relative flex flex-col w-4/5 bg-white rounded-lg">
          {/* header */}
          <div className="flex items-center justify-between w-full h-1/6 px-4 border-b border-gray-300">
            {/* title + close button */}
            <div className="flex items-center justify-between w-full h-full py-4">
              <div className="flex items-center  w-1/2 h-full">
                <h1 className="text-xl font-bold">伝票詳細</h1>
              </div>
              <div className="flex items-center justify-end w-1/2 h-full">
                <button
                  onClick={hide}
                  className="flex items-center justify-center w-8 h-8 text-gray-500 rounded-full hover:bg-gray-100"
                >
                  x
                </button>
              </div>
            </div>
          </div>
          {/* body */}
          <table className="w-full flex flex-col">
            {/* header table */}
            <thead className="w-full">
              <tr className="flex w-full h-full border-b border-gray-300 bg-[#fafafa]">
                {columns.map((column, index) => (
                  <th className="flex-1 h-full py-2" key={column.key}>
                    {column.title}
                  </th>
                ))}
              </tr>
            </thead>
            {/* body table */}
            <tbody className="w-full overflow-y-scroll ">
              {tableDataRef.current.map((item, index) => (
                <tr key={index} className="flex w-full  border-b border-gray-300">
                  <td className="w-1/3  border-r border-gray-300 py-1">
                    <div className="flex items-center justify-center w-full h-full">
                      {item.name}
                    </div>
                  </td>
                  <td className="w-1/3  border-r border-gray-300 py-1">
                    <div className="flex items-center justify-center w-full h-full">
                      {item.quantity || '-'}
                    </div>
                  </td>
                  <td className="w-1/3  border-r border-gray-300 py-1">
                    <div className="flex items-center justify-center w-full h-full">
                      {formatMoney(item?.price || 0)}
                    </div>
                  </td>
                </tr>
              ))}

              <div className="bg-[#fafafa] py-5 justify-center items-center flex space-x-2">
                <span>小計:</span>
                <span>{formatMoney(totalTable)}</span>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </>
  ) : null;
}
